export default [
    {
        path: '/procurement/vendor',
        name: 'vendor',
        props: true,
        component: () => import('@/views/procurement/vendor/index.vue'),
        meta: {
            pageTitle: 'Vendor',
            breadcrumb: [
                {
                text: 'Vendor',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/vendor/add',
        name: 'create-vendor',
        component: () => import('@/views/procurement/vendor/create.vue'),
        meta: {
            pageTitle: 'Create Vendor',
            breadcrumb: [
                {
                text: 'Vendor',
                to: { name: 'vendor' },
                },
                {
                text: 'Create Vendor',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/vendor/:id',
        name: 'detail-vendor',
        props: true,
        component: () => import('@/views/procurement/vendor/detail.vue'),
        meta: {
            pageTitle: 'Detail Vendor',
            breadcrumb: [
                {
                text: 'Vendor',
                to: { name: 'vendor' },
                },
                {
                text: 'Detail Vendor',
                active: true,
                },
            ],
        },
    },
]